import { CardContent, CardShell } from '../common';
import { cardFullWidth } from '@/utils/styleUtils';
import PayoutsOverTimeLineGraph from './PayoutsOverTimeLineGraph';
import type { PayoutRevenue } from '@/types';
import { useMetadataQuery, usePayoutDatesV2Query } from '@/services/revenueApi';

import NoDataMessage from '@/components/states/NoDataMessage';
import { useDerivedNetworkContext } from '@/context';
import { combineQueryStatuses } from '@/utils/queryUtils';
import useFetchQuery from '@/hooks/useFetchQuery';

const PayoutsOverTimeCard = () => {
  const { selectedNetwork } = useDerivedNetworkContext();
  const payoutDatesQuery = usePayoutDatesV2Query(selectedNetwork.id);
  const { queryResult: metadataQuery } = useFetchQuery(useMetadataQuery);

  const combinedStatus = combineQueryStatuses([payoutDatesQuery, metadataQuery]);

  return (
    <CardShell className={cardFullWidth}>
      <CardContent
        {...combinedStatus}
        data={payoutDatesQuery.data}
        renderData={(data) => (
          <Data
            data={data.payout_revenue}
            networkCurrency={metadataQuery.data?.currency_name ?? ''}
          />
        )}
      />
    </CardShell>
  );
};

const Data = ({ data, networkCurrency }: { data: PayoutRevenue; networkCurrency: string }) => {
  if (!data?.some((item) => Object.keys(item.totals).length > 0)) {
    return <NoDataMessage dataType="payouts" />;
  }

  return (
    <div className="my-6 mr-10">
      <PayoutsOverTimeLineGraph data={data} networkCurrency={networkCurrency} />
    </div>
  );
};

export default PayoutsOverTimeCard;
